import store, {persistor} from '@store';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import {PostHogProvider} from '@posthog/react';
import {NODE_ENV, POSTHOG_HOST, POSTHOG_TOKEN} from '@core/helpers/constants';
import posthog from 'posthog-js';
import maskCapturedNetworkRequest from '@core/analytics/networkMask';

import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const options: any = {
  api_host: POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  mask_all_element_attributes: true,
  session_recording: {
    maskAllInputs: true,
    recordCanvas: false,
    recordCrossOriginIframes: false,
    recordHeaders: true,
    recordBody: true,
    maskCapturedNetworkRequestFn: maskCapturedNetworkRequest,
  },
};

const isLocalhost = ['localhost', '127.0.0.1', '::1'].includes(
  window.location.hostname
);

const isPostHogEnabled = NODE_ENV === 'production' || NODE_ENV === 'staging';

if (isPostHogEnabled) {
  posthog.init(POSTHOG_TOKEN, options);
}

function RootApp() {
  const app = <App />;

  return (
    <Provider store={store}>
      <BrowserRouter>
        <PersistGate persistor={persistor}>
          {isPostHogEnabled ? (
            <PostHogProvider client={posthog}>{app}</PostHogProvider>
          ) : (
            app
          )}
        </PersistGate>
      </BrowserRouter>
    </Provider>
  );
}

root.render(<RootApp />);

reportWebVitals();
